module.exports = __webpack_public_path__ + "static/media/baby-massage.bf67967f.jpg";